import Layout from "../../components/Layout/Layout";
import StatsCard from "../../components/CDP/Demographics/Statscard";
import StatsCard2 from "../../components/CDP/Demographics/StatsCard2";
import DeviceChart from "../../components/CDP/Demographics/DeviceChart";
import ProductChart from "../../components/CDP/Demographics/ProductChart";
import SignUpTrend from "../../components/CDP/Demographics/SignUpTrend";
import WeeklyTrendChart from "../../components/CDP/Demographics/WeeklyTrendChart";
import BounceRate from "../../components/CDP/Demographics/BounceRate";
import SignInMenthod from "../../components/CDP/Demographics/SignInMenthod";
import RegistrationMethod from "../../components/CDP/Demographics/RegistrationMethod";
import AgeDemographicsChart from "../../components/CDP/Demographics/AgeDemographicsChart";
import GenderDemographicsChart from "../../components/CDP/Demographics/GenderDemographicsChart";
import { useCdpFilters } from "./hooks/useCdpFilters";
import CdpFilterBar from "./components/CdpFilterBar";
import CdpSubNav from "./components/CdpSubNav";
import ChartCard from "./components/ChartCard";

export default function Demographics() {
  const {
    filters,
    dateValue,
    appliedFilters,
    handleApply,
    handleReset,
    handleDateSelect,
    setDomain,
    setPlatform,
  } = useCdpFilters({ initialApplied: {} });

  return (
    <Layout>
      <main>
        <div className="mx-auto my-6 max-w-7xl px-4">
          <CdpSubNav />
          <div className="rounded-2xl bg-white text-gray-50 shadow-lg">
            <div className="py-2">
              <div className="col-span-3 border-r">
                <div className="border-b border-gray-200 px-8 py-6">
                  <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                    Demographics
                  </h2>
                </div>
                <dl className="grid grid-cols-1 border-b border-gray-200 lg:grid-cols-3">
                  <StatsCard />
                </dl>
              </div>
              <div className="grid grid-cols-1 py-10 lg:grid-cols-2">
                <div className="col-span-1 px-6 lg:px-10">
                  <ProductChart />
                </div>
                <div className="col-span-1 flex items-center">
                  <div className="w-full px-6 lg:px-10">
                    <DeviceChart />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto my-6 max-w-7xl px-4">
          <div className="rounded-2xl bg-white text-gray-50 shadow-lg">
            <CdpFilterBar
              title="Choose Your Filter"
              domain={filters.domain}
              platform={filters.platform}
              dateValue={dateValue}
              onDomainChange={setDomain}
              onPlatformChange={setPlatform}
              onDateSelect={handleDateSelect}
              onApply={handleApply}
              onReset={handleReset}
            />
            <dl className="grid grid-cols-1 border-b bg-gray-50 lg:grid-cols-3">
              {appliedFilters?.product_id ? <StatsCard2 filters={appliedFilters} /> : null}
            </dl>
          </div>
        </div>

        <div className="mx-auto my-6 max-w-7xl px-4">
          <div className="grid gap-5 grid-cols-1 lg:grid-cols-2">
            <ChartCard title="Sign Up Trend" className="col-span-1 lg:col-span-2">
              <SignUpTrend filters={appliedFilters} />
            </ChartCard>
            <ChartCard title="Weekly Trend">
              <WeeklyTrendChart filters={appliedFilters} />
            </ChartCard>
            <ChartCard title="User Bounce Rate">
              <BounceRate filters={appliedFilters} />
            </ChartCard>
            <ChartCard title="Login Source">
              <div className="py-6">
                <SignInMenthod filters={appliedFilters} />
              </div>
            </ChartCard>
            <ChartCard title="Sign-In Method">
              <div className="py-6">
                <RegistrationMethod filters={appliedFilters} />
              </div>
            </ChartCard>
            <ChartCard title="Gender Ratio">
              <div className="py-4">
                <GenderDemographicsChart filters={appliedFilters} />
              </div>
            </ChartCard>
            <ChartCard title="Age Demographics">
              <AgeDemographicsChart filters={appliedFilters} />
            </ChartCard>
          </div>
        </div>
      </main>
    </Layout>
  );
}
